import { API_URL } from "env";
import { toast } from "react-toastify";
import { FeatureType } from "../type";

async function getFeaturesListBySubId(subId: number): Promise<FeatureType[]> {
    if (!subId) return [];
    else if (!API_URL) return [];
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/subscriptions/${subId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        if (!data) {
            toast.error(data.message || "Failed to fetch features for subscription");
        }
        else {
            const returnData:FeatureType[] = data.features || [];
            return returnData;
        }
        return data || [];
    }
    catch (error) {
        toast.error("Error fetching features for subscription: " + error);
        return [];
    }
}

export default getFeaturesListBySubId;